        <div class="col-lg-12 mb-4">
            <div class="card card-table h-100">
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>Name </th>
                                    <th>Email</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody class="align-middle">
                                <tr *ngFor="let row of usersList">
                                    <td> <span class="d-flex align-items-center"><img class="avatar p-1 me-2"
                                                src="https://d19m59y37dris4.cloudfront.net/bubbly/1-2/img/avatar-0.jpg"
                                                alt="Nielsen Cobb"><span class="d-inline-block"><strong>
                                                    {{row.name}}</strong><br><span
                                                    class="text-muted text-sm">Graniteville</span></span></span></td>
                                    <td>
                                        {{row.email}}
                                    </td>
                                    <td>
                                        <a class="me-3 text-lg text-success"><i class="far fa-edit"></i></a><a
                                            class="text-lg text-danger"><i class="far fa-trash-alt"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    <div *ngIf="httpService.processing()">
        <app-progress-indicator></app-progress-indicator>
      </div>
